import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AutomaticRentRenewalService {
  private baseURL: string;

  readonly arrPendingReminders$ = new BehaviorSubject<{ name: string; deadline: string }[]>([]);

  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;;
  }
  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  getARRReminderStatus(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetARRReminderStatus`);
  }

  GetAllARRSettings(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetAllARRSettings`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

 GetNextAvailableRentalstratweek(billingcycle: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetNextAvailableRentalstratweek?billingcycle=${billingcycle}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  
  saveCombinedWeeklyRentalsARR(
    startDate: string,
    endDate: string,
    yearmonth: string,
    renewOtherCharges: boolean,
    applyPredefinedDiscount: boolean,
    excludeWithoutResale: boolean,
    excludeWithoutBusinessLicense: boolean,
    excludeWithBusinessLicense: boolean,
    notes: string,
    noOfWeeks: number,
    dateOfRenewal: any,
    paid: boolean,
    excludeARRFlag: boolean,
    ApplyARRLateFee:boolean,
    cWeeklyBookings: any[],
    otheritemchargesALL:any[],
    paymentDueDate_value:Date
): Observable<any> {
    const url = `${this.baseURL}/AutomaticRentRenewal/SaveCombinedWeeklyRentalsARR?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&yearmonth=${yearmonth}
    &Renewothercharges=${renewOtherCharges}&ApplyPredefinediscount=${applyPredefinedDiscount}
    &ExcludeWithOutresale=${excludeWithoutResale}&ExcludewithoutBussinessLicesnse=${excludeWithoutBusinessLicense}
    &ExcludeWithBussinessLicense=${excludeWithBusinessLicense}&notes=${encodeURIComponent(notes)}
    &noofweeks=${noOfWeeks}&dateofrenewal=${dateOfRenewal.toISOString()}&paid=${paid}&ExcludeARRFlag=${excludeARRFlag}&ApplyARRLateFeeUfm=${ApplyARRLateFee}&paymentDueDate=${paymentDueDate_value.toISOString()}`;
    const requestBody = {
      cweeklyBookings: cWeeklyBookings,
      UpdatedOtherRentalCharges: otheritemchargesALL
    };
    return this.http.post<any>(url, requestBody)
      .pipe(
        map(res => res as any),
        catchError(this.handleError)
      );
}

saveCombinedMonthlyRentalsARR(
  startyearmonth: string,
  numofmonths: number,
  Renewothercharges: boolean,
  ApplyPredefinediscount: boolean,
  ExcludeflagARR: boolean,
  ApplyARRLateFee: boolean,
  ExcludeWithOutresale: boolean,
  ExcludewithoutBussinessLicesnse: boolean,
  ExcludeWithBussinessLicense: boolean,
  notes: string | null,
  chunkReservations: any[],
  otheritemchargesALL: any[],
  paid: boolean,
  dateOfRenewalDate: Date,
  paymentDueDate_value: Date
): Observable<any> {

  const requestBody = {
    startYearMonth: startyearmonth,
    numOfMonths: numofmonths,
    renewOtherCharges: Renewothercharges,
    applyPredefinedDiscount: ApplyPredefinediscount,
    excludeFlagARR: ExcludeflagARR,
    applyARRLateFeeUfm: ApplyARRLateFee,
    excludeWithoutResale: ExcludeWithOutresale,
    excludeWithoutBusinessLicense: ExcludewithoutBussinessLicesnse,
    excludeWithBusinessLicense: ExcludeWithBussinessLicense,
    notes: notes,
    paid: paid,
    dateOfRenewal: dateOfRenewalDate.toISOString(),
    paymentDueDate: paymentDueDate_value.toISOString(),
    combinedMonthlyRentalsARRRequest: {
      cMonthlyBookings: chunkReservations,
      updatedOtherRentalCharges: otheritemchargesALL
    }
  };

  return this.http.post<any>(
    `${this.baseURL}/AutomaticRentRenewal/SaveCombinedMonthlyRentalsARR`,
    requestBody
  );
}


  saveWeeklyRentalsARR(
    startDate: string,
    endDate: string,
    yearmonth: string,
    renewOtherCharges: boolean,
    applyPredefinedDiscount: boolean,
    excludeWithoutResale: boolean,
    excludeWithoutBusinessLicense: boolean,
    excludeWithBusinessLicense: boolean,
    notes: string,
    noOfWeeks: number,
    dateOfRenewal: any,
    paid: boolean,
    excludeARRFlag: boolean,
    ApplyARRLateFee:boolean,
    cWeeklyBookings: any[],
    paymentDueDate_value:Date
): Observable<any> {
    const url = `${this.baseURL}/AutomaticRentRenewal/SaveWeeklyRentalsARR?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&yearmonth=${yearmonth}
    &Renewothercharges=${renewOtherCharges}&ApplyPredefinediscount=${applyPredefinedDiscount}
    &ExcludeWithOutresale=${excludeWithoutResale}&ExcludewithoutBussinessLicesnse=${excludeWithoutBusinessLicense}
    &ExcludeWithBussinessLicense=${excludeWithBusinessLicense}&notes=${encodeURIComponent(notes)}
    &noofweeks=${noOfWeeks}&dateofrenewal=${dateOfRenewal.toISOString()}&paid=${paid}&ExcludeARRFlag=${excludeARRFlag}&ApplyARRLateFeeUfm=${ApplyARRLateFee}&paymentDueDate=${paymentDueDate_value.toISOString()}`;

    return this.http.post<any>(url, cWeeklyBookings)
      .pipe(
        map(res => res as any),
        catchError(this.handleError)
      );
}


  GetMonthlyReservationforProforma(startyearmonth: string,vendorid: number,noofmonths:number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ProformaInvoice/GetMonthlyReservationforProforma?startyearmonth=${startyearmonth}&vendorid=${vendorid}&noofmonths=${noofmonths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  GetMonthlyReservationforARR(startyearmonth: string,noofmonths:number,billingcycle: string, renewOtherRentalsNoBooths: boolean): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetMonthlyReservationforARR?startyearmonth=${startyearmonth}&noofmonths=${noofmonths}&billingcycle=${billingcycle}&renewOtherRentalsNoBooths=${renewOtherRentalsNoBooths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  VoidARR(voidTransactionRequest: { Fromreceiptid: number; Toreceiptid: number; Voidreason: string }): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/AutomaticRentRenewal/VoidARRTransactions`,
      voidTransactionRequest, 
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) } 
    ).pipe(
      catchError(this.handleError) 
    );
  }
  
    GetCombinedMonthlyReservationforARR(startyearmonth: string, noofmonths: number, billingcycle: string, renewOtherRentalsNoBooths: boolean): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetCombinedMonthlyReservationforARR?startyearmonth=${startyearmonth}&noofmonths=${noofmonths}&billingcycle=${billingcycle}&renewOtherRentalsNoBooths=${renewOtherRentalsNoBooths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  GetCombinedMonthlyOtheritemReservationforARR( startyearmonth:String, numofmonths:number,
     Renewothercharges:boolean): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetOtherRentalChargesforARR_CM?startyearmonth=${startyearmonth}&numofmonths=${numofmonths}&Renewothercharges=${Renewothercharges}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

MonthlyOtheritemReservationforARR( startyearmonth:String, numofmonths:number,
    Renewothercharges:boolean): Observable<any> {
   return this.http.get<any>(
     `${this.baseURL}/AutomaticRentRenewal/GetOtherRentalChargesforARR_M?startyearmonth=${startyearmonth}&numofmonths=${numofmonths}&Renewothercharges=${Renewothercharges}`,
     { observe: 'response' }
   ).pipe(
     map(res => {
       const result = res.body as any;
       return result;
     }),
     catchError(this.handleError)
   );
 }
  GetCombinedWeeklyOtheritemReservationforARR( startDate:Date, noofweeks:number,
    Renewothercharges:boolean): Observable<any> {
   return this.http.get<any>(
     `${this.baseURL}/AutomaticRentRenewal/GetOtherRentalChargesforARR_CW?startDate=${startDate}&noofweeks=${noofweeks}&Renewothercharges=${Renewothercharges}`,
     { observe: 'response' }
   ).pipe(
     map(res => {
       const result = res.body as any;
       return result;
     }),
     catchError(this.handleError)
   );
 }
  GetCombinedWeeklyReservationforARR(startDate: string, endDate: string, yearmonth: string, noofweeks: number, dateofrenewal: any,billingcycle: string, renewOtherRentalsNoBooths: boolean): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetCombinedWeeklyReservationforARR?startDate=${startDate}&endDate=${endDate}&yearmonth=${yearmonth}&noofweeks=${noofweeks}&dateofrenewal=${dateofrenewal}&billingcycle=${billingcycle}&renewOtherRentalsNoBooths=${renewOtherRentalsNoBooths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  GetWeeklyReservationforARR(startDate: string, endDate: string, yearmonth: string, noofweeks: number, dateofrenewal: any,billingcycle: string, renewOtherRentalsNoBooths: boolean): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/AutomaticRentRenewal/GetWeeklyReservationforARR?startDate=${startDate}&endDate=${endDate}&yearmonth=${yearmonth}&noofweeks=${noofweeks}&dateofrenewal=${dateofrenewal}&billingcycle=${billingcycle}&renewOtherRentalsNoBooths=${renewOtherRentalsNoBooths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  GetMonthlyOtherReservationforProforma(startyearmonth: string,vendorid: number,noofmonths:number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ProformaInvoice/GetMonthlyOtherReservationforProforma?startyearmonth=${startyearmonth}&vendorid=${vendorid}&noofmonths=${noofmonths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  GetCombinedMonthlyOtherReservationforProforma(startyearmonth: string,vendorid: number,noofmonths:number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ProformaInvoice/GetCombinedMonthlyOtherReservationforProforma?startyearmonth=${startyearmonth}&vendorid=${vendorid}&noofmonths=${noofmonths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  getDiscountAmount(vendorId: number,rentalType: number,arcRentalChg: number,
    otherCharge: number,priorBalance: number,salesTaxAmt: number,secondLevelTaxAmt: number
  ): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ProformaInvoice/GetDiscountAmount?vendorId=${vendorId}&rentalType=${rentalType}&arcRentalChg=${arcRentalChg}&otherCharge=${otherCharge}&priorBalance=${priorBalance}&salesTaxAmt=${salesTaxAmt}&secondLevelTaxAmt=${secondLevelTaxAmt}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  GetCombinedMonthlyReservationforProforma(startyearmonth: string,vendorid: number,noofmonths:number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ProformaInvoice/GetCombinedMonthlyReservationforProforma?startyearmonth=${startyearmonth}&vendorid=${vendorid}&noofmonths=${noofmonths}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
  
  GetCombinedWeeklyReservationforProforma(vendorid: number, startDate: string, endDate: string, yearmonth: string, notes: string, paid: boolean, NumofWeeks: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/ProformaInvoice/GetCombinedWeeklyReservationforProforma?vendorid=${vendorid}&startDate=${startDate}&endDate=${endDate}&yearmonth=${yearmonth}&notes=${encodeURIComponent(notes)}&paid=${paid}&NumofWeeks=${NumofWeeks}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }
   
  saveMonthlyReservationforProforma(
    startyearmonth: string,vendorid: number,numofmonths: number,paymentduedate: Date,
    dateofInvoice: Date,Renewothercharges: boolean,ApplyPredefinediscount: boolean,ExcludeflagARR: boolean, 
    ExcludeWithOutresale: boolean,ExcludewithoutBussinessLicesnse: boolean,ExcludeWithBussinessLicense: boolean,
    notes: string,preview: boolean,reservationListForSave:any
  ): Observable<any> {
    const url = `${this.baseURL}/ProformaInvoice/SaveMonthlyReservationforProforma?startyearmonth=${startyearmonth}&vendorid=${vendorid}
      &numofmonths=${numofmonths}&paymentduedate=${paymentduedate.toISOString()}&dateofInvoice=${dateofInvoice.toISOString()}
      &Renewothercharges=${Renewothercharges}&ApplyPredefinediscount=${ApplyPredefinediscount}
      &ExcludeflagARR=${ExcludeflagARR}&ExcludeWithOutresale=${ExcludeWithOutresale}
      &ExcludewithoutBussinessLicesnse=${ExcludewithoutBussinessLicesnse}
       &ExcludeWithBussinessLicense=${ExcludeWithBussinessLicense}&notes=${encodeURIComponent(notes)}&preview=${preview}`;
    return this.http.post<any>(url, reservationListForSave)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }
  saveCombinedMonthlyReservationforProforma(
    startyearmonth: string,vendorid: number,numofmonths: number,paymentduedate: Date,
    dateofInvoice: Date,Renewothercharges: boolean,ApplyPredefinediscount: boolean,ExcludeflagARR: boolean, 
    ExcludeWithOutresale: boolean,ExcludewithoutBussinessLicesnse: boolean,ExcludeWithBussinessLicense: boolean,
    notes: string,preview: boolean,reservationListForSave:any
  ): Observable<any> {
    const url = `${this.baseURL}/ProformaInvoice/SaveCombinedMonthlyReservationforProforma?startyearmonth=${startyearmonth}&vendorid=${vendorid}
      &numofmonths=${numofmonths}&paymentduedate=${paymentduedate.toISOString()}&dateofInvoice=${dateofInvoice.toISOString()}
      &Renewothercharges=${Renewothercharges}&ApplyPredefinediscount=${ApplyPredefinediscount}
      &ExcludeflagARR=${ExcludeflagARR}&ExcludeWithOutresale=${ExcludeWithOutresale}
      &ExcludewithoutBussinessLicesnse=${ExcludewithoutBussinessLicesnse}
       &ExcludeWithBussinessLicense=${ExcludeWithBussinessLicense}&notes=${encodeURIComponent(notes)}&preview=${preview}`;
    return this.http.post<any>(url, reservationListForSave)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }
  saveMonthlyRentalsARR(
    startyearmonth: string,
    numofmonths: number,
    Renewothercharges: boolean,
    ApplyPredefinediscount: boolean,
    ExcludeflagARR: boolean,
    ApplyARRLateFee:boolean,
    ExcludeWithOutresale: boolean,
    ExcludewithoutBussinessLicesnse: boolean,
    ExcludeWithBussinessLicense: boolean,
    notes: string | null,
    Mothlylistloop: any,
    otheritemchargesALL:any[],
    paid: boolean,
    dateofrenewal: Date,
    paymentDueDate_value:Date
  ): Observable<any> {
    const url = `${this.baseURL}/AutomaticRentRenewal/SaveMonthlyRentalsARR?` +
      `startyearmonth=${startyearmonth}` +
      `&numofmonths=${numofmonths}` +
      `&Renewothercharges=${Renewothercharges}` +
      `&ApplyPredefinediscount=${ApplyPredefinediscount}` +
      `&ExcludeflagARR=${ExcludeflagARR}` +
      `&ApplyARRLateFeeUfm=${ApplyARRLateFee}` +
      `&ExcludeWithOutresale=${ExcludeWithOutresale}` +
      `&ExcludewithoutBussinessLicesnse=${ExcludewithoutBussinessLicesnse}` +
      `&ExcludeWithBussinessLicense=${ExcludeWithBussinessLicense}` +
      `&notes=${notes || ''}` +
      `&paid=${paid}` +
      `&dateofrenewal=${dateofrenewal.toISOString()}` +
      `&paymentDueDate=${paymentDueDate_value.toISOString()}`;
      const requestBody = {
        MonthlyBookings: Mothlylistloop,
        UpdatedOtherRentalCharges: otheritemchargesALL
      };
    return this.http.post<any>(url, requestBody)
      .pipe(
        map(res => res as any),
        catchError(this.handleError)
      );
  }
  

  combinePdfs(base64Pdfs: string[]): Observable<{ Success: boolean, CombinedPdf: string }> {
    return this.http.post<{ Success: boolean, CombinedPdf: string }>(this.baseURL + '/PaymentReceipt/combine',base64Pdfs);
  }

  displayProformaInvoice(proformaInvoiceIds: number[],email): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/DisplayProformaInvoice?email=${email}`;
     return this.http.post<any>(url, proformaInvoiceIds, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }
  
  displayARRReceipts(accountreceiptids: number[],rentaltype,email): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/DisplayARRReceipts?Rentaltype=${rentaltype}&email=${email}`;
     return this.http.post<any>(url, accountreceiptids, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }
  DisplayVoidARRReceipts(accountreceiptids: number[],email): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/PaymentReceipt/DisplayVoidARRReceipts?email=${email}`;
     return this.http.post<any>(url, accountreceiptids, options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }
  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
